// Each section has its own cast. The Tweak pair intentionally shares an identity.
export const landingArtwork = {
  cafeCompanion: {
    src: '/assets/landing-polish/companion.webp',
    alt: 'AI-created woman with dark curls in a cream tank and plum overshirt at a café',
  },
  cafeBlonde: {
    src: '/assets/landing-polish/hero.webp',
    alt: 'AI-created blonde woman in a red casual top outside a café',
  },
  tealAnime: {
    src: '/assets/landing-polish/anime.webp',
    alt: 'AI-created teal-haired anime character in casual nighttime fashion',
  },
  redheadAnime: {
    src: '/assets/landing-polish/studio-redhead-anime-v1.webp',
    alt: 'AI-created auburn-haired anime woman in an olive tank and beige shirt in a courtyard',
  },
  redheadTweak: {
    src: '/assets/landing-polish/studio-redhead-anime-tweak-v1.webp',
    alt: 'The same anime woman with a blue tank and charcoal shirt on a seaside boardwalk',
  },
  rooftopBlonde: {
    src: '/assets/landing-polish/rooftop-blonde-v1.webp',
    alt: 'AI-created blonde woman in a black tank beside a rooftop pool at dusk',
  },
  galleryCurls: {
    src: '/assets/landing-polish/studio-black-curls-v1.webp',
    alt: 'AI-created woman with long dark curls in a sage tank outside a seaside art gallery',
  },
  cafeAnime: {
    src: '/assets/landing-polish/everyday-anime.webp',
    alt: 'AI-created blonde anime woman in a white tank and blue overshirt at a sunset café',
  },
  gardenRedhead: {
    src: '/assets/landing-polish/studio-freckled-v1.webp',
    alt: 'AI-created copper-haired woman with freckles in a blue tank beside a garden greenhouse',
  },
}
